import { Button, Checkbox, Skeleton } from 'antd';
import React, { useState, useEffect, ReactElement, ReactNode } from 'react';
import { useSelector } from 'react-redux';
import FormModal from '../../../../../../shared/components/modal/FormModal';
import {
  authFeatureConstants,
  FACILITY_GROUP_NAME,
  FETCH_ALL_FACILITY_TYPE,
} from '../../../../../../shared/constants/commonConstants';
import { LookUpDetail, SearchLookUpResponse } from '../../../../../../shared/models/lookUp.model';
import SendRequest from '../../../../../../shared/services/sendRequest.service';
import { canActivate } from '../../../../../../utils/utility';
import './Facilities.less';
import Facility from './Facility/Facility';

export interface FacilityProps {
  facilityName: string;
  isApplicable: boolean;
}
const Facilities = (props: any): ReactElement => {
  const [selectedFacilities, setSelectedFacilities] = useState(
    [] as FacilityProps[],
  );
  const [isAddFacility, setIsAddFacility] = useState(false);
  const [facilityList, setFacilityList] = useState([] as string[]);
  const [selectedModalFacilities, setSelectedModalFacilities] = useState([] as FacilityProps[]);
  const [isAPICall, setIsAPICall] = useState(true);
  const apiHospitalProfile = useSelector(({ hospital: { hospitalProfile } }: any): any => hospitalProfile);
  const saveFacilityMasterList = async (): Promise<any> => {
    if (facilityList === null || facilityList.length === 0) {
      setIsAPICall(true);
      const fetchUrl = `${process.env.REACT_APP_BASE_URL}${FETCH_ALL_FACILITY_TYPE}`;
      const res: SearchLookUpResponse = await SendRequest.instance.get<any>(
        fetchUrl,
      );
      setIsAPICall(false);
      if (res && res.isSuccess && res.lookUpData.length > 0) {
        setFacilityList(
          res.lookUpData
            .sort((a: LookUpDetail, b: LookUpDetail): number => {
              return a.value.localeCompare(b.value);
            })
            .filter((x: LookUpDetail): boolean => x.isActive)
            .map((item: LookUpDetail): any => {
              return item.value;
            }),
        );
      }
    }
  };
  const onAddFacility = (): void => {
    setIsAddFacility(true);
    saveFacilityMasterList();
    setSelectedModalFacilities(selectedFacilities);
  };
  const onModalClose = (): void => {
    setIsAddFacility(false);
  };
  useEffect((): void => {
    if (
      apiHospitalProfile &&
      apiHospitalProfile.length > 0 &&
      apiHospitalProfile[0] &&
      apiHospitalProfile[0].properties &&
      apiHospitalProfile[0].properties.length > 0 &&
      apiHospitalProfile[0].properties.filter(
        (x: any): boolean => x.groupName === FACILITY_GROUP_NAME,
      ).length > 0
    ) {
      const values = apiHospitalProfile[0].properties
        .filter((x: any): boolean => x.groupName === FACILITY_GROUP_NAME)
        .map(
          (item: any): FacilityProps => {
            return {
              facilityName: item.name,
              isApplicable: item.value.toLowerCase() === 'true' ? true : false,
            };
          },
        );
      setSelectedFacilities(values);
    }
    // eslint-disable-next-line
  }, [apiHospitalProfile]);

  const onRemoveFacility = (facility: string): void => {
    const allApplicableFacilities = [...selectedFacilities];
    const index: number = allApplicableFacilities.findIndex(
      (x: any): boolean =>
        x.facilityName.toLowerCase() === facility.toLowerCase(),
    );
    if (index !== -1) {
      allApplicableFacilities[index].isApplicable = false;
      setSelectedFacilities(allApplicableFacilities);
      props.facilities(allApplicableFacilities);
    }
  };

  const onFacilityCheckBoxChange = (checkedList: any): void => {
    const list: FacilityProps[] = checkedList.map(
      (x: string): FacilityProps => {
        return { facilityName: x, isApplicable: true };
      },
    );
    const presentFacilities = selectedFacilities.map(
      (x: FacilityProps): FacilityProps => {
        return { facilityName: x.facilityName, isApplicable: false };
      },
    );
    const merge = (a: any, b: any, p: string): any =>
      a
        .filter((aa: any): any => !b.find((bb: any): any => aa[p] === bb[p]))
        .concat(b);
    setSelectedModalFacilities(merge(presentFacilities, list, 'facilityName'));
  };

  const onModalSave = (): void => {
    setSelectedFacilities(selectedModalFacilities);
    props.facilities(selectedModalFacilities);
    setIsAddFacility(false);
  };
  const getElements = (): any => {
    return selectedFacilities
      .filter((x: FacilityProps): boolean => x.isApplicable === true)
      .map(
        (item: FacilityProps, id: number): ReactNode => {
          return (
            <div key={id}>
              <Facility
                name={item.facilityName}
                onRemoveFacility={onRemoveFacility}
              />
            </div>
          );
        },
      );
  };
  return (
    <React.Fragment>
      <h5 className="h5 mt-lg">{props.heading}</h5>
      <div className="facilities-list">{getElements()}</div>
      {
        canActivate(authFeatureConstants.EDIT_HOSPITAL_PROFILE) &&
        <Button
          onClick={onAddFacility}
          className="mt-md"
        >
          + Add Facility
        </Button>
      }
      <FormModal
        visible={isAddFacility}
        onCancel={onModalClose}
        title={'Add Facility'}
        isFooter={false}
      >
        {isAPICall ?
          (<Skeleton active={true} paragraph={{ rows: 4 }} />) :
          (
            <>
              <Checkbox.Group
                className="fecilities-checkbox mb-md"
                options={facilityList}
                value={selectedModalFacilities
                  .filter((x: FacilityProps): boolean => x.isApplicable)
                  .map((x: FacilityProps): string => {
                    return x.facilityName;
                  })}
                onChange={onFacilityCheckBoxChange}
              />
              <div className="text-right">
                <Button onClick={onModalSave} type="primary">
                  Add
          </Button>
              </div>
            </>
          )
        }
      </FormModal>
    </React.Fragment>
  );
};

export default Facilities;
